module.exports = __webpack_public_path__ + "assets/dianliushiyan.1ef50e83.svg";